<section class="site-dashboard">
  <app-card variant="default" padding="none" class="sites-table-card table-card">

<div *ngIf="loading" class="loading-container">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        <p>Loading sites...</p>
      </div>

      <div *ngIf="!loading && sites.length === 0" class="empty-state">
        <div class="empty-state__icon">
          <mat-icon>store</mat-icon>
        </div>
        <h3>No sites yet</h3>
        <p>Create your first site location to get started.</p>
        <button mat-flat-button color="primary" (click)="onCreateSite()" *appHasPermission="'site.create'">
          <mat-icon>add</mat-icon>
          Create First Site
        </button>
      </div>

      <div *ngIf="!loading && sites.length > 0" class="table-container">
        <table mat-table [dataSource]="sites" class="modern-table">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Site</th>
            <td mat-cell *matCellDef="let site">
              <div class="site-cell">
                <div class="site-cell__icon">
                  <mat-icon class="grocery">storefront</mat-icon>
                </div>
                <div class="site-cell__details">
                  <strong class="site-cell__name">{{ site.name }}</strong>
                  <span class="site-cell__description" *ngIf="site.description">{{ site.description }}</span>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let site">
              <span class="status-badge" [class.active]="site.is_active" [class.inactive]="!site.is_active">
                <span class="status-indicator"></span>
                {{ site.is_active ? 'Active' : 'Inactive' }}
              </span>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let site">
              <button mat-icon-button [matMenuTriggerFor]="siteMenu" matTooltip="More actions"
                class="action-menu-trigger">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #siteMenu="matMenu" class="action-menu">
                <button mat-menu-item (click)="onEditSite(site)" *appHasPermission="'site.update'">
                  <mat-icon>edit</mat-icon>
                  <span>Edit Site</span>
                </button>
                <button mat-menu-item (click)="onViewSite(site)" *appHasPermission="'site.read'">
                  <mat-icon>visibility</mat-icon>
                  <span>View Details</span>
                </button>
                <button mat-menu-item (click)="onManageUsers(site)" *appHasPermission="'user.management'">
                  <mat-icon>people</mat-icon>
                  <span>Manage Users</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="onDeleteSite(site)" class="danger-action"
                  *appHasPermission="'site.delete'">
                  <mat-icon>delete</mat-icon>
                  <span>Delete Site</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
  </app-card>
</section>